import React from 'react';
import intl from 'react-intl-universal';
import { PageTitle } from 'src/ui/library/PageTitle';

const Help = () => (
  <div className="content">
    <PageTitle title={intl.get('help.pageTitle')} />
    <h1>{intl.get('help.title')}</h1>
    <div className="instructions">
      {intl.get('help.instructions.general.body')}
      <a className="link" href="mailto:pathway.support@ey.com">
        pathway.support@ey.com
      </a>
    </div>
    {/*<h1>{intl.get('help.title')}</h1>
    <h4>{intl.get('help.instructions.general.title')}</h4>
    <div className="instructions">{intl.get('help.instructions.general.body')}</div>
    <h4>{intl.get('help.instructions.technology.title')}</h4>
    <div className="instructions">
      {intl.get('help.instructions.technology.body')}
      <a className="link" href="mailto:pathway.support@ey.com">
        pathway.support@ey.com
      </a>
    </div>*/}
  </div>
);

export default Help;
